<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/basic
ib-row
    ib-col(class="scroll", class="flex  after-8", style="max-height:65vh;")
        ib-table-basic(
            :data="listedResults"
            row,
            colborder
            class="fs7 fg70 shrink",
            spacing="huge",
            style="border: 1px solid rgba(0,0,0,0.15); overscroll-behavior:contain;"
        )
            ib-table-col(width="30ch", sticky, class="header")
                div(class="border-bottom", @click.stop="sortResults('id', '')")
                    span(:title="$t('description')") {{ $t('description') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'asc' }", 
                        @click.stop="sortResults('id', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'desc' }", 
                        @click.stop="sortResults('id', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="14ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('assets', '')")
                    span(:title="$t('product')") {{ $t('product') }}
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'asc' }", 
                        @click.stop="sortResults('assets', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'desc' }", 
                        @click.stop="sortResults('assets', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            ib-table-col(width="14ch", class="header")
                div(class="border-bottom", @click.stop="sortResults('country', '')")
                    span(:title="$t('region')") {{ $t('region', '') }}`
                    span(
                        class="up",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'asc' }", 
                        @click.stop="sortResults('country', 'asc')"
                    )
                        +icon-arrow-sort_up_filled
                    span(
                        class="down",
                        :class="{'active-sort': previousSort.type === 'company' && previousSort.dir === 'desc' }", 
                        @click.stop="sortResults('country', 'desc')"
                    )
                        +icon-arrow-sort_down_filled
            template(slot="body", slot-scope="res")
                td
                    ib-button(
                        appearance="link", 
                        class="description", 
                        @click="exchangeOverview(res['id'])",
                        :title="res['name']"
                    ) {{ res['id'] }} ({{ res['name'] }})
                td(:title="res['assets']") {{ res['assets'] }}
                td(:title="res['country']") {{ res['country'] }}
    
        div(v-if="listedResults.length > 0", class="pagination")
                div(class="dropdownStyle")
                    ib-dropdown(
                        :data="dropdownData",
                        v-model="numShow",
                        :placeholder="$t('show_rows')",
                        align="center"
                    )
                div(class="pagination-style")
                    span {{ $t('page') }}
                    ib-field(
                        :disabled="totalPage <= 1",
                        width="7ch",
                        align="center",
                        placeholder=1,
                        class="outsetx-8",
                        v-model="pageNumber",
                        @change="changePage"
                    )
                    span {{ $t('of') }}
                        strong(style="margin-left:4px;") {{ totalPage }}
                    ib-button(:disabled="pageNumber <= 1", @click="changePage(--pageNumber)", class="page-btn")
                        +icon-arrow-back
                    ib-button(:disabled="pageNumber >= totalPage", @click="changePage(++pageNumber)", class="page-btn")
                        +icon-arrow-forward
    
</template>
<script>

    import { mapState, mapActions, mapGetters } from 'vuex';
    import api from '../api/index.js'

    export default {
        name: 'ExchangeResults',
        components: {
        },
        data() {
            return {
                value: '',
                show: true,
                direction: false,
            }
        },
        watch: {
            numShow(newValue, oldValue){
                Vue.nextTick(() => {
                    this.setTypesList([]);
                    this.setStatus('loading');
                    this.search();
                });
            },
        },
        mounted() {
            const notes = document.querySelector('.notes');
            const asxExchange = this.listedResults.find(result => result.country === 'Australia');
            const exchangeSpecificDisclosure = document.querySelector('.exchange-specific-disclosure');
            console.debug("asxExchange value is: ", asxExchange);
            if(asxExchange && this.status === 'exchangeResults'){
                if(notes){
                    notes.style.display = "block";
                }
                exchangeSpecificDisclosure.style.display = "block";
            }
        },
        methods: {
            exchangeOverview(val) {
                this.setCurrentSort({ type: 'symbol', dir: 'asc'});
                this.setselectedExch(val);
                console.debug('selected exchange is', this.selectedExch)
                console.debug('API call to to fetch Exchange information .............')
                const options = {
                    pageNumber: 1,
                    pageSize: 100,
                    sortField: this.currentSort.type,
                    sortDirection: this.currentSort.dir,
                    domain: this.selectedDomain,
                }
                this.setProducts([]);
                this.setStatus('loading');
                api.getProductsByExchange(val,options)
                    .then(response => {
                        if(response.products.length === 0){
                            $alert('No results found');
                            this.setStatus('exchangeResults');
                        } else {
                            this.setProducts(response.products);
                            let uniqueTypes = [];

                            // Functionality to create the list of product type with their product count
                            response.productTypeCount.map(product => {
                                const pdt = this.productTypes.find(type => type.symbol === product.productType);
                                uniqueTypes.push({name: pdt.name, symbol: pdt.symbol, totalCount: product.totalCount});
                            })
                            console.debug(uniqueTypes);
                            
                            // Sort in product types in a particular order
                            uniqueTypes.sort((a, b) => this.preferredProductTypeOrder[a.symbol] - this.preferredProductTypeOrder[b.symbol]);
                            
                            this.setTypesList(uniqueTypes);
                            this.setSelectedProductType("all");

                            // Setting the total count of the page for the pre selected product on results page
                            this.setTotalPages(response.productCount);

                            // Populating the results table with pre selected product type
                            const filteredResponse = response.products;
                            
                            // Filter results based on restriction for various products types
                            let restrictedProducts = this.restrictedProducts.map(product => product.symbol);
                            let results = [];
                            for(let i=0; i<this.products.length; i++){
                                if(this.selectedDomain === 'jp'){
                                    if(!restrictedProducts.includes(this.products[i].symbol)){
                                        results.push(this.products[i]);
                                    } else {
                                        console.debug("restricted product: ", this.products[i].symbol);
                                    }
                                } else if(this.products[i].type === 'CRYPTO') {
                                    if(this.allowedCryptoProducts.includes(this.products[i].symbol)){
                                        results.push(this.products[i]);
                                    }
                                } else {
                                    results.push(this.products[i]);
                                }
                                
                                const warning = this.searchResults.find(product => product.type === 'OPT' || product.type === 'FUT' || product.type === 'FOP');
                                console.debug("warning status", this.showWarning);
                                if(warning) {
                                    this.setShowWarning(true);
                                } else {
                                    this.setShowWarning(false);
                                }
                                
                                this.setStatus('prodResults');
                            }

                            this.setProductResults(filteredResponse);
                            this.setSearchResults(filteredResponse);

                            // Funcitonality to show/hide 250, 500 options in Show Rows dropdown
                            if(this.searchResults.length < 100){
                                this.setResultStatus(false);
                            } else {
                                this.setResultStatus(true);
                            }

                            // Updated status flag to display results
                            this.setStatus('prodResults');
                            this.setApiStatus('results');
                            
                        }
                    })
                    .catch(error => console.error(error))
                api.getOrderTypesByExchange(val)
                    .then(response => {
                        let natives = response.natives;
                        let simulated = response.simulated;
                        let assetTypes = response.assetType;
                        let appendCount = simulated.length - natives.length;
                        for(let i=0; i < appendCount ; i++) {
                            natives.push("");
                        }
                        let orderTypesData = [];
                        let nativeSize = natives.length;
                        let assetTypeSize = assetTypes.length;
                        for(let i = 0; i < simulated.length; i++){
                            let temp = {};
                            if(nativeSize != 0){
                                temp.native = natives[i];
                                nativeSize--;
                            }
                            temp.simulate = simulated[i];
                            temp.assetType = assetTypes.toString().toLowerCase();
                            orderTypesData.push(temp);
                        }
                        this.setOrderTypesResults(orderTypesData);
                    })
            },
            sortResults(type, dir) {
                this.updateSortOptions(type, dir);
                console.debug("current sort", this.currentSort.type, this.currentSort.dir);

                // Don't sort column again if already sorted.
                if (this.previousSort.type && (this.previousSort.type === type && this.previousSort.dir === dir)) {
                    return;
                }
                
                this.setStatus('loading');
                this.search();
            },
            changePage(value) {
                if (isNaN(value)) return;
                this.pageNumber = value;
                this.search();
            },
            updateSortOptions(type, dir){
                let sortOptions = {};
                console.debug("previous sort", this.previousSort.type, this.previousSort.dir, dir, sortOptions);
                if(dir.length === 0){
                    if(this.previousSort.dir === 'desc'){
                        sortOptions['dir'] = 'asc';
                    } else {
                        sortOptions['dir'] = 'desc';
                    }
                    sortOptions['type'] = type;
                } else {
                    sortOptions['type'] = type;
                    sortOptions['dir'] = dir;
                }

                this.setCurrentSort(sortOptions);
            },
            ...mapActions(['setselectedExch', 'setProducts', 'setTypesList', 'setSelectedProductType', 
            'setTotalPages', 'setOrderTypesResults','setProductResults', 'setStatus', 'setSearchResults',
            'setListedResults', 'setNumShow', 'search', 'setPageNumber', 'setResultStatus', 'setApiStatus', 'setCurrentSort', 'setShowWarning'])
        },
        computed : {
            dropdownData: function() {
                if(this.resultStatus === false){
                    return ['100'].map(text => this.$t('show') + " "+ text + " " + this.$t('rows'));    
                } else {
                    return ['100','250'].map(text => this.$t('show') + " "+ text + " " + this.$t('rows'));
                } 
            },
            totalPage: function() {
                return parseInt((this.totalPages / this.numShow.split(' ')[1])+ 1)
            },
            pageNumber: {
                get: function() {
                    return this.$store.state.pageNumber;
                },
                set: function(newValue) {
                    this.setPageNumber(newValue);
                }
            },
            numShow: {
                get: function() {
                    return this.$store.state.numShow;
                },
                set: function(newValue) {
                    this.setNumShow(newValue);
                }
            },
            ...mapGetters(['selectedDomain', 'preferredProductTypeOrder']),
            ...mapState(['listedResults','productResults', 'products', 'selectedExch',
                 'orderTypesResults', 'status', 'totalPages', 'resultStatus', 'resultStatus', 'searchResults', 
                 'restrictedProducts', 'allowedCryptoProducts', 'typesList', 'productTypes', 'currentSort', 'previousSort', 'showWarning']),
        },
    }
</script>
<style lang="less" scoped>
.header {
    background-color: white;
}
span {
    .up {
        position: relative;
        right: -8.5px;
        top: -6px;
        &.active-sort {
            color: #000;
        }
    }
    .down {
        position: relative;
        left: -5px;
        top: 4px;
        &.active-sort {
            color: #000;
        }
    }
}
.external-icon {
    svg {
        position: relative;
        top: 2px;
        left: 6px;
        width: 1em;
        height: 1em;
    }
}
.description {
    color: red;
    cursor: pointer;
    white-space:nowrap;
    width: 100%;
    text-align: left;
    text-wrap: wrap;
    word-wrap: break-word;
}
td {
    text-wrap: wrap;
    word-wrap: break-word;
}
.dropdownStyle {
    float: right;
}
.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pagination-style {
    display: flex;
    align-items: center;
}
</style>